import axios from "axios";
import React, { useState } from "react";
import { changePassword } from "./apis";
import { Header } from "../Layouts/Header";
import { useNavigate } from "react-router-dom";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChange, setPasswordChange] = useState({
    msg: "",
    status: "",
  });
  const [passwordError, setPasswordError] = useState({
    oldPassword: "",
    newPassWord: "",
  });
  const [orderModal, setOrderModal] = useState(false);
  const navigate = useNavigate();
  // const [changePassword_error]
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  const updatePassword = () => {
    if (oldPassword.length === 0) {
      setPasswordError({
        ...passwordError,
        oldPassword: "Please Enter Old Password",
      });
      return false;
    } else if (newPassword.length === 0) {
      setPasswordError({
        ...passwordError,
        newPassWord: "Please Enter Password",
      });
      return false;
    } else if (confirmPassword.length === 0) {
      setPasswordError({
        ...passwordError,
        newPassWord: "Please Enter Confirm Password",
      });
      return false;
    } else if (newPassword != confirmPassword) {
      setPasswordError({
        ...passwordError,
        newPassWord: "New password and confirm password not match",
      });
      return false;
    } else {
      let payload = {
        oldPassword: oldPassword,
        password: newPassword,
      };
      axios
        .post(changePassword, { payload }, { headers: headers })
        .then((res) => {
          if (res?.data?.status === 200) {
            console.log(res?.data);
            if (res?.data?.password === false) {
              setPasswordChange({
                ...passwordChange,
                msg: "Old Password Not Match",
                status: false,
              });
            } else {
              setPasswordChange({
                ...passwordChange,
                msg: "Password Change Successfully",
                status: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const closeModel = () => {
    navigate(-1);
  };

  return (
    <>
      <Header
        userName={user?.name}
        // move_floor={handleMove}
      />
      <h4 className="heading_design">Change Password</h4>
      <br />
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="container formdesign">
              <p className="text-danger">{passwordError.oldPassword}</p>
              <p className="text-danger">{passwordError.newPassWord}</p>
              <p
                className={
                  passwordChange.status ? "text-success" : "text-danger"
                }
              >
                {passwordChange.msg}
              </p>
              <label className="inputdesign">Old Password</label>
              <input
                type="password"
                placeholder="Enter your old Password"
                className="inputdesign"
                value={oldPassword}
                onChange={(e) => {
                  setPasswordError({
                    ...passwordError,
                    newPassWord: "",
                    oldPassword: "",
                  });
                  setOldPassword(e.target.value);
                }}
              />
              <br />
              <br />
              <label className="inputdesign">New Password</label>
              <input
                type="password"
                placeholder="Enter your new password"
                className="inputdesign"
                value={newPassword}
                onChange={(e) => {
                  setPasswordError({
                    ...passwordError,
                    newPassWord: "",
                    oldPassword: "",
                  });
                  setNewPassword(e.target.value);
                }}
              />
              <br />
              <br />
              <label className="inputdesign">Confirm Password</label>
              <input
                type="password"
                placeholder="Enter your confirm password"
                className="inputdesign"
                value={confirmPassword}
                onChange={(e) => {
                  setPasswordError({
                    ...passwordError,
                    newPassWord: "",
                    oldPassword: "",
                  });
                  setConfirmPassword(e.target.value);
                }}
              />
              <br />
              <br />
              <br />
              <button
                className="btn btn-primary btn_set"
                onClick={updatePassword}
              >
                Update Password
              </button>
              <button
                className="btn btn-secondary active ml-2"
                roll="button"
                onClick={closeModel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
